import { Spin } from 'antd';

import { spinner } from './spinner.module.css';

export const Spinner = () => <Spin size='large' className={spinner} />;
